import PropTypes from 'prop-types';
import React from 'react';

import './Tile.scss';

export default class Tile extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * string of title
         */
        title: PropTypes.string.isRequired,
        /**
         * node of icon
         */
        icon: PropTypes.node.isRequired,
    };

    render() {
        return (
            <div className="component-Resources-Tile">
                {this.props.icon}
                <span>{this.props.title}</span>
            </div>
        );
    }
}
